<template>
  <div>
    <div class="form-container ou-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <FormSection title="Donation Amount">
            <div style="position: relative">
              <AmountSelector />
              <ErrorLabel field="amount" style="text-align: right" />
            </div>
          </FormSection>
          <FormSection v-if="form.amount">
            <TransactionFee dept="JSU of St. Louis"/>
          </FormSection>
          <FormSection title="Donation Frequency">
            <div class="frequency">
              <PaymentOptions addMonthly addSplit/>
            </div>
          </FormSection>         
          <FormSection title="Notes">
            <FormRow>
              <FormInput type="textarea" class="width-half" field="custom.Notes" />
            </FormRow>
          </FormSection>
          <FormSection>
            <InHonorOf />
          </FormSection>
          <FormSection title="Personal Information">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
              <Consent privacy="https://jsu.org/privacy-policy/"/>
            </FormRow>  
          </FormSection>
          <FormSection title="Billing Information">
            <DonorAddress />
            <FormRow>
                  <NewsletterSubscribe text="Sign me up for newsletter" />
            </FormRow> 
              <br>                
          </FormSection>
          <FormSection title="Payment Information" last>
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
          </FormSection>
          <PaymentButton showAmount btnText="Donate Now" />
        </PaymentForm>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

export default defineComponent({
  setup() {
    const { setValue, form, getValue } = usePaymentForm();

    return {
      form,
      getValue,
      setValue,
    };
  },
});
</script>
<style scoped lang="scss">
::v-deep h2 {
  color: #1aa8d3;
  font-weight: bold;
  font-size: 22px;
  margin-bottom: 25px;
}

::v-deep .form-container.ou-donation-form {
  max-width: 100%;
  padding: 0px !important;
  box-shadow: none !important;
}
::v-deep
  .styled-radio-container--ou-donation.styled-radio-container
  input[type="radio"]:checked
  + label {
  background: #1aa8d3;
}
::v-deep hr {
  background: none;
  box-shadow: none;
  height: 0;
  border: none;
  margin-bottom: 20px;
  border-bottom: 1px solid #efefef;
}

::v-deep .styled-radio--ou-donation.styled-radio .radio-part {
  @media (min-width: 720px) {
    min-width: 33.3%;
    flex: 1;
    max-width: 33.3%;
  }
}

.designation {
  display: flex;
  width: 100%;
  position: relative;
  ::v-deep select {
    flex: 1;
    min-width: 50%;
    max-width: 50%;
    margin-right: 1%;
  }
  ::v-deep select:last-child {
    margin-right: 0;
  }
}

::v-deep .control-label{
  text-align: left !important;
}
</style>
